import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ...{
        resource: 'files',

        // Custom endpoint for file deletion
        remove(params) {
            return ApiService.post('delete-file', params)
        }
    }
}
